import LinkIcon from '@mui/icons-material/Link';
import ClearIcon from '@mui/icons-material/Clear';
import { Link } from '@material-ui/core';
import { IconButton } from '@mui/material';

interface LinkBoxProps {
  url: string;
  onRemoveLink?: () => void;
}

const LinkBox: React.FC<LinkBoxProps> = ({ url, onRemoveLink }) => {
  return (
    <div
      style={{
        border: '1px solid #ced4da',
        borderRadius: '3px',
        padding: '5px',
        display: 'inline-flex',
        alignItems: 'center',
        fontFamily: 'Roboto',
        fontSize: '14px',
      }}
    >
      <LinkIcon style={{ height: '20px', marginRight: '5px' }} />
      <Link href={url} target="_blank" rel="noopener">
        <div
          style={{
            maxWidth: '20vw',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {url}
        </div>
      </Link>
      {onRemoveLink && (
        <IconButton disableRipple onClick={onRemoveLink} style={{ padding: '3px' }}>
          <ClearIcon style={{ fontSize: '0.8em' }} />
        </IconButton>
      )}
    </div>
  );
};

export default LinkBox;
